import TopCard from "../components/TopCard";
import PopularBrands from "./PopularBrands";
import PopularCuisines from "./PopularCuisines";
import PopularRestaurant from "./PopularRestaurant";
import DiningHome from "./DiningHome";
import GroupOrderBanner from "../components/GroupOrderBanner";
import { useDining } from "../context/DiningContext";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const { enableDining, toggleDining } = useDining();
  const navigate = useNavigate();

  if (enableDining) {
    return <DiningHome />;
  }

  return (
    <div className="max-w-[1400px] mx-auto p-2 md:p-5 bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300 ">
      <TopCard />
      <PopularCuisines />
      <PopularBrands />
      <PopularRestaurant />
      <GroupOrderBanner />
      {/* Quick link used when browsing in delivery mode */}
      <button
        className="fixed bottom-24 right-4 md:hidden z-40 px-4 py-3 rounded-full bg-[#7402A7] text-white shadow-lg text-sm font-semibold"
        onClick={() => {
          toggleDining();
          navigate("/");
        }}
      >
        Dining
      </button>
    </div>
  );
};

export default Home;
